import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router'

import { WEBPAGES } from './../../../utilities/EL/WebPages'

import { GetCurrentTheme, GetUserData as BLGetUserData, UpdateNickname as BLUpdateNickname } from './../../../utilities/BL/Settings'
import { useFloatMessage, MESSAGE_TYPE } from './../../Providers/FloatMessage'
import { ChangeProfile as BLChangeProfile, GetCurrentCenter as BLGetCurrentCenter } from './../../../utilities/BL/Navigation'
import { LogErrors } from './../../../utilities/LogErrors'

import { Details } from './../../Common/Modals/Details'

import { Dashboard as HelpZtudentDashboard } from './../../../Support/Ztudent/Dashboard'
import { Course as HelpZtudentCourse } from './../../../Support/Ztudent/Course'
import { Results as HelpZtudentResults } from './../../../Support/Ztudent/Results'

import { Dashboard as HelpInstructorDashboard } from './../../../Support/Instructor/Dashboard'
import { Groups as HelpInstructorGroups } from './../../../Support/Instructor/Groups'
import { Create as HelpInstructorGroupsCreate } from './../../../Support/Instructor/Group/Create'
import { Group as HelpInstructorGroup } from './../../../Support/Instructor/Group'
import { Ztudents as HelpInstructorZtudents } from './../../../Support/Instructor/Ztudents'
import { ChangeGroup as HelpInstructorChangeGroup } from '../../../Support/Instructor/ChangeGroup'
import { Agenda as HelpInstructorAgenda } from './../../../Support/Instructor/Agenda'
import { Progress as HelpInstructorProgress } from './../../../Support/Instructor/Progress'
import { Results as HelpInstructorResults } from './../../../Support/Instructor/Results'
import { ZtudentView as HelpInstructorZtudentView } from './../../../Support/Instructor/ZtudentView'
import { Syllabus as HelpInstructorSyllabus } from './../../../Support/Instructor/Syllabus'

import { Dashboard as HelpLeaderDashboard } from './../../../Support/Leader/Dashboard'

import { Confirm } from './../../Common/Modals/Confirm'
import { HELP_TYPE } from './../../../utilities/EL/HelpType'
import { TYPE_PROPOSITION_VALUE } from './../../../utilities/EL/TypePropositionValue'
import { ROLES } from './../../../utilities/EL/Roles'


const SideMenu = ({ page, theme, propositionValue, idHelp, role }) => {
    const navigate = useNavigate()
    const { showMessage } = useFloatMessage()

    const [menuOptions, setMenuOptions] = useState(null)

    // --- Modales existentes ---
    const [showPropositionValueModal, setShowPropositionValueModal] = useState(false)
    const [showHelpModal, setShowHelpModal] = useState(false)
    const [showMyAccountModal, setShowMyAccountModal] = useState(false)
    const [showInteroperabilityModal, setShowInteroperabilityModal] = useState(false)
    const [userData, setUserData] = useState(false)

    // --- NUEVOS estados para editar alias / nickname ---
    const [showEditNicknameModal, setShowEditNicknameModal] = useState(false)      // Modal para capturar el nuevo alias
    const [showConfirmNicknameModal, setShowConfirmNicknameModal] = useState(false) // Modal de confirmación
    const [nicknameInput, setNicknameInput] = useState('')                         // Valor que se escribe en el input
    const [pendingNickname, setPendingNickname] = useState(null)                   // Alias pendiente de guardar (para confirmar)
    const [isSavingNickname, setIsSavingNickname] = useState(false)                // Bandera mientras se guarda en el servidor

    //const [currentCenter, setCurrentCenter] = useState(null)

    const [showMenubar, setShowMenubar] = useState(false)


    // /**
    //  * Cambia el centro/perfil del usuario.
    //  */
    // const ChangeProfile = async () => {
    //     try {
    //         const response = await BLChangeProfile()

    //         if (response.success) {
    //             navigate('/')
    //         } else {
    //             showMessage({
    //                 type: MESSAGE_TYPE.BAD,
    //                 text: response.message
    //             })
    //         }
    //     } catch (error) {
    //         await LogErrors('ChangeProfile - SideMenu', error)
    //     }
    // }

    const LoadMenuOptions = async () => {
        try {
            switch (role) {
                case ROLES.ZTUDENT:
                    setMenuOptions({
                        "sections": [
                            {
                                "title": 'Secciones',
                                "isOptionsSystem": false,
                                "options": [
                                    {
                                        "text": 'Dashboard',
                                        "icon": page === WEBPAGES.ZTUDENT.DASHBOARD ? 'bi bi-display-fill' : 'bi bi-display',
                                        "type": 1,
                                        "url": '/dashboard',
                                        "active": page === WEBPAGES.ZTUDENT.DASHBOARD ? true : false
                                    }
                                    //,
                                    // {
                                    //     "text": 'Mis resultados',
                                    //     "icon": 'bi bi-check-circle',
                                    //     "type": 1,
                                    //     "url": '/results',
                                    //     "active": page === WEBPAGES.ZTUDENT.RESULTS ? true : false
                                    // }
                                ]
                            },
                            {
                                "title": 'Sistema',
                                "isOptionsSystem": true,
                                "options": [
                                    {
                                        "text": 'Configuración',
                                        "icon": 'bi bi-gear',
                                        "type": 4
                                    },
                                    {
                                        "text": 'Conoce tu perfil',
                                        "icon": 'bi bi-person-circle',
                                        "type": 2,
                                        "typeHelp": idHelp
                                    },
                                    {
                                        "text": 'Ayuda',
                                        "icon": 'bi bi-question-circle',
                                        "type": 1,
                                        "url": '/help'
                                    },
                                    {
                                        "text": 'Propuesta de valor',
                                        "icon": 'bi bi-file-earmark-text',
                                        "type": 3,
                                        "propositionType": propositionValue
                                    }
                                ]
                            }
                        ]
                    })
                    break

                case ROLES.INSTRUCTOR:
                    // Obtener los datos del centro
                    const response = await BLGetCurrentCenter()
                    let centerId = null 
                    
                    if (response.success) {
                        let tmpCenterId = response?.data?.id

                        if (!tmpCenterId) {
                            return
                        }

                        // Si el dato viene como cadena, convertirlo a entero
                        if (typeof tmpCenterId === "string") {
                            tmpCenterId = parseInt(tmpCenterId)
                        }
                        
                        centerId = tmpCenterId
                    }


                    if (centerId) {
                        if (centerId === 2 || centerId === 318) {
                            setMenuOptions({
                                "sections": [
                                    {
                                        "title": 'Secciones',
                                        "isOptionsSystem": false,
                                        "options": [
                                            {
                                                "text": 'Dashboard',
                                                "icon": page === WEBPAGES.INSTRUCTOR.DASHBOARD ? 'bi bi-display-fill' : 'bi bi-display',
                                                "type": 1,
                                                "url": '/dashboard',
                                                "active": page === WEBPAGES.INSTRUCTOR.DASHBOARD ? true : false
                                            },
                                            {
                                                "text": 'Mis grupos',
                                                "icon": page === WEBPAGES.INSTRUCTOR.GROUPS ? 'bi bi-collection-fill' : 'bi bi-collection',
                                                "type": 1,
                                                "url": '/instructor/groups',
                                                "active": page === WEBPAGES.INSTRUCTOR.GROUPS ? true : false
                                            },
                                            {
                                                "text": 'Todos los Ztudiantes',
                                                "icon": page === WEBPAGES.INSTRUCTOR.ZTUDENTS ? 'bi bi-people-fill' : 'bi bi-people',
                                                "type": 1,
                                                "url": '/instructor/ztudents',
                                                "active": page === WEBPAGES.INSTRUCTOR.ZTUDENTS ? true : false
                                            },
                                            {
                                                "text": 'Cambiar de grupo',
                                                "icon": 'bi bi-arrow-left-right',
                                                "type": 1,
                                                "url": '/instructor/changeGroup',
                                                "active": page === WEBPAGES.INSTRUCTOR.CHANGE_GROUP ? true : false
                                            },
                                            {
                                                "text": 'Agenda',
                                                "icon": 'bi bi-calendar4-week',
                                                "type": 1,
                                                "url": '/instructor/agenda',
                                                "active": page === WEBPAGES.INSTRUCTOR.AGENDA ? true : false
                                            },
                                            {
                                                "text": 'Progreso',
                                                "icon": 'bi bi-list-check',
                                                "type": 1,
                                                "url": '/instructor/progress',
                                                "active": page === WEBPAGES.INSTRUCTOR.PROGRESS ? true : false
                                            },
                                            {
                                                "text": 'Resultados',
                                                "icon": page === WEBPAGES.INSTRUCTOR.RESULTS ? 'bi bi-bar-chart-fill' : 'bi bi-bar-chart',
                                                "type": 1,
                                                "url": '/instructor/results',
                                                "active": page === WEBPAGES.INSTRUCTOR.RESULTS ? true : false
                                            },
                                            {
                                                "text": 'Vista del Ztudiante',
                                                "icon": 'bi bi-person-bounding-box',
                                                "type": 1,
                                                "url": '/instructor/ztudentView',
                                                "active": page === WEBPAGES.INSTRUCTOR.ZTUDENTVIEW ? true : false
                                            },
                                            {
                                                "text": 'Temarios',
                                                "icon": 'bi bi-list-task',
                                                "type": 1,
                                                "url": '/instructor/syllabus',
                                                "active": page === WEBPAGES.INSTRUCTOR.SYLLABUS ? true : false
                                            },
                                            {
                                                "text": 'Contáctanos',
                                                "icon": 'bi bi-whatsapp',
                                                "type": 1,
                                                "url": '/instructor/support',
                                                "active": page === WEBPAGES.INSTRUCTOR.SUPPORT ? true : false
                                            },
                                            {
                                                "text": 'Configuraciones',
                                                "icon": page === WEBPAGES.INSTRUCTOR.SETTINGS ? 'bi bi-gear-fill' : 'bi bi-gear',
                                                "type": 1,
                                                "url": '/instructor/settings',
                                                "active": page === WEBPAGES.INSTRUCTOR.SETTINGS ? true : false
                                            }
                                        ]
                                    },
                                    {
                                        "title": 'Sistema',
                                        "isOptionsSystem": true,
                                        "options": [
                                            {
                                                "text": 'Configuración',
                                                "icon": 'bi bi-gear',
                                                "type": 4
                                            },
                                            {
                                                "text": 'Conoce tu perfil',
                                                "icon": 'bi bi-person-circle',
                                                "type": 2,
                                                "typeHelp": idHelp
                                            },
                                            {
                                                "text": 'Ayuda',
                                                "icon": 'bi bi-question-circle',
                                                "type": 1,
                                                "url": '/instructor/help'
                                            },
                                            {
                                                "text": 'Propuesta de valor',
                                                "icon": 'bi bi-file-earmark-text',
                                                "type": 3,
                                                "propositionType": propositionValue
                                            },
                                            {
                                                "text": 'Interoperabilidad',
                                                "icon": 'bi bi-info-circle',
                                                "type": 5
                                            }
                                        ]
                                    }
                                ]
                            })
                        } else {
                            setMenuOptions({
                                "sections": [
                                    {
                                        "title": 'Secciones',
                                        "isOptionsSystem": false,
                                        "options": [
                                            {
                                                "text": 'Dashboard',
                                                "icon": page === WEBPAGES.INSTRUCTOR.DASHBOARD ? 'bi bi-display-fill' : 'bi bi-display',
                                                "type": 1,
                                                "url": '/dashboard',
                                                "active": page === WEBPAGES.INSTRUCTOR.DASHBOARD ? true : false
                                            },
                                            {
                                                "text": 'Mis grupos',
                                                "icon": page === WEBPAGES.INSTRUCTOR.GROUPS ? 'bi bi-collection-fill' : 'bi bi-collection',
                                                "type": 1,
                                                "url": '/instructor/groups',
                                                "active": page === WEBPAGES.INSTRUCTOR.GROUPS ? true : false
                                            },
                                            {
                                                "text": 'Todos los Ztudiantes',
                                                "icon": page === WEBPAGES.INSTRUCTOR.ZTUDENTS ? 'bi bi-people-fill' : 'bi bi-people',
                                                "type": 1,
                                                "url": '/instructor/ztudents',
                                                "active": page === WEBPAGES.INSTRUCTOR.ZTUDENTS ? true : false
                                            },
                                            {
                                                "text": 'Cambiar de grupo',
                                                "icon": 'bi bi-arrow-left-right',
                                                "type": 1,
                                                "url": '/instructor/changeGroup',
                                                "active": page === WEBPAGES.INSTRUCTOR.CHANGE_GROUP ? true : false
                                            },
                                            {
                                                "text": 'Agenda',
                                                "icon": 'bi bi-calendar4-week',
                                                "type": 1,
                                                "url": '/instructor/agenda',
                                                "active": page === WEBPAGES.INSTRUCTOR.AGENDA ? true : false
                                            },
                                            {
                                                "text": 'Progreso',
                                                "icon": 'bi bi-list-check',
                                                "type": 1,
                                                "url": '/instructor/progress',
                                                "active": page === WEBPAGES.INSTRUCTOR.PROGRESS ? true : false
                                            },
                                            {
                                                "text": 'Resultados',
                                                "icon": page === WEBPAGES.INSTRUCTOR.RESULTS ? 'bi bi-bar-chart-fill' : 'bi bi-bar-chart',
                                                "type": 1,
                                                "url": '/instructor/results',
                                                "active": page === WEBPAGES.INSTRUCTOR.RESULTS ? true : false
                                            },
                                            {
                                                "text": 'Temarios',
                                                "icon": 'bi bi-list-task',
                                                "type": 1,
                                                "url": '/instructor/syllabus',
                                                "active": page === WEBPAGES.INSTRUCTOR.SYLLABUS ? true : false
                                            },
                                            {
                                                "text": 'Contáctanos',
                                                "icon": 'bi bi-whatsapp',
                                                "type": 1,
                                                "url": '/instructor/support',
                                                "active": page === WEBPAGES.INSTRUCTOR.SUPPORT ? true : false
                                            },
                                            {
                                                "text": 'Configuraciones',
                                                "icon": page === WEBPAGES.INSTRUCTOR.SETTINGS ? 'bi bi-gear-fill' : 'bi bi-gear',
                                                "type": 1,
                                                "url": '/instructor/settings',
                                                "active": page === WEBPAGES.INSTRUCTOR.SETTINGS ? true : false
                                            }
                                        ]
                                    },
                                    {
                                        "title": 'Sistema',
                                        "isOptionsSystem": true,
                                        "options": [
                                            {
                                                "text": 'Configuración',
                                                "icon": 'bi bi-gear',
                                                "type": 4
                                            },
                                            {
                                                "text": 'Conoce tu perfil',
                                                "icon": 'bi bi-person-circle',
                                                "type": 2,
                                                "typeHelp": idHelp
                                            },
                                            {
                                                "text": 'Ayuda',
                                                "icon": 'bi bi-question-circle',
                                                "type": 1,
                                                "url": '/instructor/help'
                                            },
                                            {
                                                "text": 'Propuesta de valor',
                                                "icon": 'bi bi-file-earmark-text',
                                                "type": 3,
                                                "propositionType": propositionValue
                                            }
                                        ]
                                    }
                                ]
                            })
                        }
                    } else {
                        setMenuOptions({
                            "sections": [
                                {
                                    "title": 'Secciones',
                                    "isOptionsSystem": false,
                                    "options": [
                                        {
                                            "text": 'Dashboard',
                                            "icon": page === WEBPAGES.INSTRUCTOR.DASHBOARD ? 'bi bi-display-fill' : 'bi bi-display',
                                            "type": 1,
                                            "url": '/dashboard',
                                            "active": page === WEBPAGES.INSTRUCTOR.DASHBOARD ? true : false
                                        },
                                        {
                                            "text": 'Mis grupos',
                                            "icon": page === WEBPAGES.INSTRUCTOR.GROUPS ? 'bi bi-collection-fill' : 'bi bi-collection',
                                            "type": 1,
                                            "url": '/instructor/groups',
                                            "active": page === WEBPAGES.INSTRUCTOR.GROUPS ? true : false
                                        },
                                        {
                                            "text": 'Todos los Ztudiantes',
                                            "icon": page === WEBPAGES.INSTRUCTOR.ZTUDENTS ? 'bi bi-people-fill' : 'bi bi-people',
                                            "type": 1,
                                            "url": '/instructor/ztudents',
                                            "active": page === WEBPAGES.INSTRUCTOR.ZTUDENTS ? true : false
                                        },
                                        {
                                            "text": 'Cambiar de grupo',
                                            "icon": 'bi bi-arrow-left-right',
                                            "type": 1,
                                            "url": '/instructor/changeGroup',
                                            "active": page === WEBPAGES.INSTRUCTOR.CHANGE_GROUP ? true : false
                                        },
                                        {
                                            "text": 'Agenda',
                                            "icon": 'bi bi-calendar4-week',
                                            "type": 1,
                                            "url": '/instructor/agenda',
                                            "active": page === WEBPAGES.INSTRUCTOR.AGENDA ? true : false
                                        },
                                        {
                                            "text": 'Progreso',
                                            "icon": 'bi bi-list-check',
                                            "type": 1,
                                            "url": '/instructor/progress',
                                            "active": page === WEBPAGES.INSTRUCTOR.PROGRESS ? true : false
                                        },
                                        {
                                            "text": 'Resultados',
                                            "icon": page === WEBPAGES.INSTRUCTOR.RESULTS ? 'bi bi-bar-chart-fill' : 'bi bi-bar-chart',
                                            "type": 1,
                                            "url": '/instructor/results',
                                            "active": page === WEBPAGES.INSTRUCTOR.RESULTS ? true : false
                                        },
                                        {
                                            "text": 'Temarios',
                                            "icon": 'bi bi-list-task',
                                            "type": 1,
                                            "url": '/instructor/syllabus',
                                            "active": page === WEBPAGES.INSTRUCTOR.SYLLABUS ? true : false
                                        },
                                        {
                                            "text": 'Contáctanos',
                                            "icon": 'bi bi-whatsapp',
                                            "type": 1,
                                            "url": '/instructor/support',
                                            "active": page === WEBPAGES.INSTRUCTOR.SUPPORT ? true : false
                                        },
                                        {
                                            "text": 'Configuraciones',
                                            "icon": page === WEBPAGES.INSTRUCTOR.SETTINGS ? 'bi bi-gear-fill' : 'bi bi-gear',
                                            "type": 1,
                                            "url": '/instructor/settings',
                                            "active": page === WEBPAGES.INSTRUCTOR.SETTINGS ? true : false
                                        }
                                    ]
                                },
                                {
                                    "title": 'Sistema',
                                    "isOptionsSystem": true,
                                    "options": [
                                        {
                                            "text": 'Configuración',
                                            "icon": 'bi bi-gear',
                                            "type": 4
                                        },
                                        {
                                            "text": 'Conoce tu perfil',
                                            "icon": 'bi bi-person-circle',
                                            "type": 2,
                                            "typeHelp": idHelp
                                        },
                                        {
                                            "text": 'Ayuda',
                                            "icon": 'bi bi-question-circle',
                                            "type": 1,
                                            "url": '/instructor/help'
                                        },
                                        {
                                            "text": 'Propuesta de valor',
                                            "icon": 'bi bi-file-earmark-text',
                                            "type": 3,
                                            "propositionType": propositionValue
                                        }
                                    ]
                                }
                            ]
                        })
                    }
                    break

                case ROLES.LEADER:
                    setMenuOptions({
                        "sections": [
                            {
                                "title": 'Secciones',
                                "isOptionsSystem": false,
                                "options": [
                                    {
                                        "text": 'Dashboard',
                                        "icon": page === WEBPAGES.LEADER.DASHBOARD ? 'bi bi-display-fill' : 'bi bi-display',
                                        "type": 1,
                                        "url": '/dashboard',
                                        "active": page === WEBPAGES.LEADER.DASHBOARD ? true : false
                                    },
                                    {
                                        "text": 'Mis instructores',
                                        "icon": page === WEBPAGES.LEADER.INSTRUCTORS ? 'bi bi-people-fill' : 'bi bi-people',
                                        "type": 1,
                                        "url": '/leader/instructors',
                                        "active": page === WEBPAGES.LEADER.INSTRUCTORS ? true : false
                                    },
                                    {
                                        "text": 'Mover grupos',
                                        "icon": 'bi bi-arrow-left-right',
                                        "type": 1,
                                        "url": '/leader/groups',
                                        "active": page === WEBPAGES.LEADER.CHANGE_GROUP ? true : false
                                    },
                                    {
                                        "text": 'Licencias Ztudia',
                                        "icon": 'bi bi-files',
                                        "type": 1,
                                        "url": '/leader/licenses',
                                        "active": page === WEBPAGES.LEADER.ZTUDENTS ? true : false
                                    },
                                    {
                                        "text": 'Generar constancias',
                                        "icon": page === WEBPAGES.LEADER.CERTIFICATES ? 'bi bi-stickies-fill' : 'bi bi-stickies',
                                        "type": 1,
                                        "url": '#', //"url": '/leader/certificates',
                                        "active": page === WEBPAGES.LEADER.CERTIFICATES ? true : false
                                    },
                                    {
                                        "text": 'Resultados de los Ztudiantes',
                                        "icon": 'bi bi-list-check',
                                        "type": 1,
                                        "url": '/leader/reports',
                                        "active": page === WEBPAGES.LEADER.REPORTS ? true : false
                                    },
                                    {
                                        "text": 'Progreso de los Ztudiantes',
                                        "icon": page === WEBPAGES.LEADER.PROGRESS ? 'bi bi-bar-chart-fill' : 'bi bi-bar-chart',
                                        "type": 1,
                                        "url": '/leader/progress',
                                        "active": page === WEBPAGES.LEADER.PROGRESS ? true : false
                                    },
                                    {
                                        "text": 'Contáctanos',
                                        "icon": 'bi bi-whatsapp',
                                        "type": 1,
                                        "url": '/leader/support',
                                        "active": page === WEBPAGES.LEADER.SUPPORT ? true : false
                                    }
                                    // {
                                    //     "text": 'Espacio de Ztudiantes',
                                    //     "icon": 'bi bi-list-check',
                                    //     "type": 1,
                                    //     "url": '/leader/ztudents',
                                    //     "active": page === WEBPAGES.LEADER.ZTUDENTS_SPACE ? true : false
                                    // }
                                ]
                            },
                            {
                                "title": 'Sistema',
                                "isOptionsSystem": true,
                                "options": [
                                    {
                                        "text": 'Configuración',
                                        "icon": 'bi bi-gear',
                                        "type": 4
                                    },
                                    {
                                        "text": 'Conoce tu perfil',
                                        "icon": 'bi bi-person-circle',
                                        "type": 2,
                                        "typeHelp": idHelp
                                    },
                                    {
                                        "text": 'Ayuda',
                                        "icon": 'bi bi-question-circle',
                                        "type": 1,
                                        "url": '/leader/help'
                                    },
                                    {
                                        "text": 'Propuesta de valor',
                                        "icon": 'bi bi-file-earmark-text',
                                        "type": 3,
                                        "propositionType": propositionValue
                                    }
                                ]
                            }
                        ]
                    })
                    break

                default:
                    break
            }
        } catch (error) {
            
        }
    }

    

    /**
     * Carga la información inicial del header:
     * - Datos de la cuenta del usuario
     */
    const LoadPage = async () => {
        try {
            // Cargar las opciones del menú dependiendo el perfil / página
            await LoadMenuOptions(idHelp)

            // Obtener los datos de la cuenta del usuario
            const response = await BLGetUserData()

            if (response.success) {
                setUserData(response.data)
            }
        } catch (error) {
            await LogErrors('LoadPage - SideMenu', error)
        }
    }

    /**
     * Abre el modal para editar el alias.
     * Precarga el alias actual en el input.
     */
    const OpenEditNicknameModal = async () => {
        try {
            if (!userData) return

            // Usamos el alias actual como valor inicial
            setNicknameInput(userData.nickname ?? '')
            setShowEditNicknameModal(true)
        } catch (error) {
            await LogErrors('OpenEditNicknameModal - SideMenu', error)
        }
    }

    /**
     * Maneja el clic en "Guardar cambios" dentro del modal de edición.
     * No guarda todavía en el servidor, solo:
     * - Valida el texto
     * - Guarda el alias pendiente
     * - Muestra el modal de confirmación
     */
    const HandleNicknameSubmit = async () => {
        try {
            if (!userData) return

            const trimmedNickname = (nicknameInput ?? '').trim()

            // Validar que no esté vacío
            if (!trimmedNickname) {
                showMessage({
                    type: MESSAGE_TYPE.BAD,
                    text: 'Debes escribir un alias para poder cambiarlo'
                })
                return
            }

            // Si no cambia nada, no tiene sentido confirmar ni llamar al backend
            const currentNickname = (userData.nickname ?? '').trim()
            if (trimmedNickname === currentNickname) {
                showMessage({
                    type: MESSAGE_TYPE.BAD,
                    text: 'Escribe tu nuevo alias' //No has realizado ningún cambio en tu alias
                })
                return
            }

            // Guardamos el alias pendiente y mostramos el modal de confirmación
            setPendingNickname(trimmedNickname)
            setShowEditNicknameModal(false)
            setShowConfirmNicknameModal(true)
        } catch (error) {
            await LogErrors('HandleNicknameSubmit - SideMenu', error)
        }
    }

    /**
     * Envía la petición al backend para actualizar el alias del usuario.
     * Utiliza la función BLUpdateNickname (ya existente en la capa BL).
     */
    const UpdateNickname = async () => {
        try {
            if (!pendingNickname) return

            setIsSavingNickname(true)

            const response = await BLUpdateNickname(pendingNickname)

            if (response.success) {
                // Mostrar mensaje de éxito
                showMessage({
                    type: MESSAGE_TYPE.SUCCESS,
                    text: 'Se ha actualizado tu alias de manera exitosa'
                })

                // Actualizar el alias en el estado local para reflejar el cambio en pantalla
                setUserData(prev => {
                    if (!prev) return prev
                    return {
                        ...prev,
                        nickname: pendingNickname
                    }
                })
            } else {
                // Mostrar mensaje de error regresado por el backend
                showMessage({
                    type: MESSAGE_TYPE.BAD,
                    text: response.message
                })
            }
        } catch (error) {
            await LogErrors('UpdateNickname - SideMenu', error)
            showMessage({
                type: MESSAGE_TYPE.BAD,
                text: 'No ha sido posible actualizar tu alias. Inténtalo nuevamente o inténtalo más tarde'
            })
        } finally {
            // Cerrar modal de confirmación y limpiar estados
            setIsSavingNickname(false)
            setShowConfirmNicknameModal(false)
            setPendingNickname(null)
        }
    }

    useEffect(() => {
        LoadPage()
    },[])


    return (
        <>
            <div className='SideMenu__Menu__CloseButton--Floating'>
                <button type='button' className='Btn__Ztudia--PrimaryOutline SideMenu__Menu__CloseButton--Floating__Button' onClick={() => setShowMenubar(!showMenubar)}><i className='bi bi-list'></i></button>
            </div>

            <aside className={`SideMenu__Menu Fonts--PlusJakartaSans ${showMenubar && 'SideMenu__Menu--Show'}`}>
                <div className={`SideMenu__Menu__Container ${showMenubar && 'SideMenu__Menu__Container--Show'}`}>
                    <div className='SideMenu__Menu__Header'>
                        {theme && theme === 2 ? (
                            <img src="/img/brand/Ztudia-Logotipo-Blanco-66x26.png" />
                        ) : (
                            <img src="/img/brand/Ztudia-Logotipo-Negro-66x26.png" />
                        )}

                        <button type='button' className='Btn__Ztudia--PrimaryOutline SideMenu__Menu__Header__CloseButton SideMenu__Menu__Header__CloseButton--Floating' onClick={() => setShowMenubar(!showMenubar)}><i className='bi bi-x-lg'></i></button>
                    </div>
                    
                    {menuOptions && (
                        menuOptions.sections && (
                            menuOptions.sections.map((section, index) => (
                                section.isOptionsSystem === false && (
                                    <nav key={index} className='SideMenu__Menu__Sections'>
                                        <p className='SideMenu__Menu__Sections__Title'>{section.title}</p>

                                        <ul className='SideMenu__Menu__Sections__Lists'>
                                            {section.options.map((option, subindex) => (
                                                option.type === 1 ? (
                                                    <li key={subindex} className={`SideMenu__Menu__Sections__Lists__Items ${option.active && 'SideMenu__Menu__Sections__Lists__Items--Active'}`} title={option.text} onClick={() => navigate(option.url)}>
                                                        <i className={`SideMenu__Menu__Sections__Lists__Items__Icon ${option.icon}`}></i> {option.text} {/*option.active ? 'Sí' : 'No'*/}
                                                    </li>
                                                ) : option.type === 2 ? (
                                                    <li key={subindex} className='SideMenu__Menu__Sections__Lists__Items' title={option.text} onClick={() => setShowHelpModal(true)}>
                                                        <i className={`SideMenu__Menu__Sections__Lists__Items__Icon ${option.icon}`}></i> {option.text}
                                                    </li>
                                                ) : option.type === 3 ? (
                                                    <li key={subindex} className='SideMenu__Menu__Sections__Lists__Items' title={option.text} onClick={() => setShowPropositionValueModal(true)}>
                                                        <i className={`SideMenu__Menu__Sections__Lists__Items__Icon ${option.icon}`}></i> {option.text}
                                                    </li>
                                                ) : option.type === 4 ? (
                                                    <li key={subindex} className='SideMenu__Menu__Sections__Lists__Items' title={option.text} onClick={() => setShowMyAccountModal(true)}>
                                                        <i className={`SideMenu__Menu__Sections__Lists__Items__Icon ${option.icon}`}></i> {option.text}
                                                    </li>
                                                ) : option.type === 5 && (
                                                    <li key={subindex} className='SideMenu__Menu__Sections__Lists__Items' title={option.text} onClick={() => setShowInteroperabilityModal(true)}>
                                                        <i className={`SideMenu__Menu__Sections__Lists__Items__Icon ${option.icon}`}></i> {option.text}
                                                    </li>
                                                )
                                            ))}
                                        </ul>
                                    </nav>
                                )
                            ))
                        )
                    )}
                </div>

                <div className={`SideMenu__Menu__Container ${showMenubar && 'SideMenu__Menu__Container--Show'}`}>
                    {menuOptions && (
                        menuOptions.sections && (
                            menuOptions.sections.map((section, index) => (
                                section.isOptionsSystem && (
                                    <nav key={index} className='SideMenu__Menu__Sections'>
                                        <p className='SideMenu__Menu__Sections__Title'>{section.title}</p>

                                        <ul className='SideMenu__Menu__Sections__Lists'>
                                            {section.options.map((option, subindex) => (
                                                option.type === 1 ? (
                                                    <li key={subindex} className='SideMenu__Menu__Sections__Lists__Items' title={option.text} onClick={() => navigate(option.url)}>
                                                        <i className={`SideMenu__Menu__Sections__Lists__Items__Icon ${option.icon}`}></i> {option.text}
                                                    </li>
                                                ) : option.type === 2 ? (
                                                    <li key={subindex} className='SideMenu__Menu__Sections__Lists__Items' title={option.text} onClick={() => setShowHelpModal(true)}>
                                                        <i className={`SideMenu__Menu__Sections__Lists__Items__Icon ${option.icon}`}></i> {option.text}
                                                    </li>
                                                ) : option.type === 3 ? (
                                                    <li key={subindex} className='SideMenu__Menu__Sections__Lists__Items' title={option.text} onClick={() => setShowPropositionValueModal(true)}>
                                                        <i className={`SideMenu__Menu__Sections__Lists__Items__Icon ${option.icon}`}></i> {option.text}
                                                    </li>
                                                ) : option.type === 4 ? (
                                                    <li key={subindex} className='SideMenu__Menu__Sections__Lists__Items' title={option.text} onClick={() => setShowMyAccountModal(true)}>
                                                        <i className={`SideMenu__Menu__Sections__Lists__Items__Icon ${option.icon}`}></i> {option.text}
                                                    </li>
                                                ) : option.type === 5 && (
                                                    <li key={subindex} className='SideMenu__Menu__Sections__Lists__Items' title={option.text} onClick={() => setShowInteroperabilityModal(true)}>
                                                        <i className={`SideMenu__Menu__Sections__Lists__Items__Icon ${option.icon}`}></i> {option.text}
                                                    </li>
                                                )
                                            ))}
                                        </ul>
                                    </nav>
                                )
                            ))
                        )
                    )}

                    <div className='SideMenu__Menu__UserData'>
                        <img src='/img/brand/favicon/favicon.ico' className='SideMenu__Menu__UserData__Image' />

                        <div className='SideMenu__Menu__UserData__Text'>
                            <p className='SideMenu__Menu__UserData__Text__Item' title={userData.name}>{userData.name}</p>
                            <p className='SideMenu__Menu__UserData__Text__Item'>{role === ROLES.DISTRIBUTOR ? 'Distribuidor' : role === ROLES.INSTRUCTOR ? 'Instructor' : role === ROLES.LEADER ? 'Líder de proyecto' : 'Ztudiante'}</p>
                        </div>
                    </div>
                </div>
            </aside>

            {/* <div className='SideMenu__Menu'>
                <button type='button' className='Btn__Ztudia--PrimaryOutline SideMenu__Menu__Header__CloseButton' onClick={() => setShowMenubar(!showMenubar)}><i className='bi bi-x-lg'></i></button>
            </div> */}

            {/* ======================= MODAL PROPUESTA DE VALOR ======================= */}
            {showPropositionValueModal && (
                <Details
                    showCloseModalButtonInContent={true}
                    extraClassName={'Instructor__Ztudents__Details'}
                    setShowModal={setShowPropositionValueModal}
                >
                    <div className='Instructor__Ztudents__Details__Container'>
                        <p className='Instructor__Ztudents__Details__Title'><i className='bi bi-file-earmark-text'></i> Propuesta de valor</p>

                        {propositionValue === TYPE_PROPOSITION_VALUE.ZTUDENT ? (
                            <>
                                <p>Ztudia es una solución educativa que te acompaña en el desarrollo de habilidades digitales esenciales para tu formación académica y profesional.</p>
                                <p>A través de un recorrido estructurado por niveles, aprenderás a dominar herramientas como Word, Excel, PowerPoint, Photoshop, programación y desarrollo web.</p>
                                <p>Cada bloque de contenido incluye teoría clara, videos explicativos, cuestionarios interactivos y desafíos prácticos que te permiten aplicar lo aprendido de forma dinámica y significativa.</p>
                                <p>Además, participarás en actividades grupales que fortalecen tu comprensión y fomentan el trabajo colaborativo.</p>
                                <p>Tu docente es quien guía tu proceso: establece cuándo iniciar cada bloque, activa los contenidos y da seguimiento a tu avance.</p>
                                <p>Las evaluaciones se aplican y califican automáticamente, y puedes consultar tus resultados desde tu perfil.</p>
                                <p>Con Ztudia, aprendes a tu ritmo, con autonomía, pero siempre acompañado.</p>
                            </>
                        ) : propositionValue === TYPE_PROPOSITION_VALUE.INSTRUCTOR ? (
                            <>
                                <p>Ztudia es una solución educativa diseñada para facilitar la enseñanza de competencias digitales mediante una estructura clara, completa y lista para usar.</p>
                                <p>Ofrece un temario progresivo, organizado por bloques de conocimiento que cubren herramientas clave como Word, Excel, PowerPoint, Photoshop, Principios de Programación, Programación Orientada a Objetos y Desarrollo Web.</p>
                                <p>Cada bloque incluye contenido teórico, cuestionarios, videos y desafíos prácticos, todo previamente diseñado para que el docente pueda implementarlo directamente en el aula sin necesidad de crear materiales adicionales.</p>
                                <p>Además, incorpora actividades grupales estructuradas que refuerzan el aprendizaje colaborativo, y evaluaciones que se aplican y califican automáticamente, mostrando los resultados en los perfiles del docente y del alumno.</p>
                                <p>El docente solo necesita definir fechas y activar los contenidos, lo que simplifica la planificación y ejecución de sus clases.</p>
                                <p>Esta automatización y estructura permiten optimizar el tiempo del docente, facilitar la gestión pedagógica y fortalecer la calidad del proceso de enseñanza-aprendizaje.</p>
                            </>
                        ) : propositionValue === TYPE_PROPOSITION_VALUE.LEADER && (
                            <>
                                {/* <p>Ztudia es una solución educativa diseñada para facilitar la enseñanza de competencias digitales mediante una estructura clara, completa y lista para usar.</p>
                                <p>Ofrece un temario progresivo, organizado por bloques de conocimiento que cubren herramientas clave como Word, Excel, PowerPoint, Photoshop, Principios de Programación, Programación Orientada a Objetos y Desarrollo Web.</p>
                                <p>Cada bloque incluye contenido teórico, cuestionarios, videos y desafíos prácticos, todo previamente diseñado para que el docente pueda implementarlo directamente en el aula sin necesidad de crear materiales adicionales.</p>
                                <p>Además, incorpora actividades grupales estructuradas que refuerzan el aprendizaje colaborativo, y evaluaciones que se aplican y califican automáticamente, mostrando los resultados en los perfiles del docente y del alumno.</p> */}
                                {/* <p>El docente solo necesita definir fechas y activar los contenidos, lo que simplifica la planificación y ejecución de sus clases.</p>
                                <p>Esta automatización y estructura permiten optimizar el tiempo del docente, facilitar la gestión pedagógica y fortalecer la calidad del proceso de enseñanza-aprendizaje.</p> */}
                            </>
                        )}
                    </div>
                </Details>
            )}

            {/* ======================= MODAL DE AYUDA ======================= */}
            {showHelpModal && (
                <Details
                    showCloseModalButtonInContent={false}
                    extraClassName={'Instructor__Ztudents__Details'}
                    setShowModal={setShowHelpModal}
                >
                    <div className='Instructor__Ztudents__Details__Container'>
                        <p className='Instructor__Ztudents__Details__Title'><i className="bi bi-question-circle"></i> Ayuda</p>

                        {idHelp === HELP_TYPE.ZTUDENT.DASHBOARD ? (
                            <HelpZtudentDashboard />
                        ) : idHelp === HELP_TYPE.ZTUDENT.COURSE ? (
                            <HelpZtudentCourse />
                        ) : idHelp === HELP_TYPE.ZTUDENT.RESULTS ? (
                            <HelpZtudentResults />
                        ) : idHelp === HELP_TYPE.INSTRUCTOR.GROUPS ? (
                            <HelpInstructorGroups />
                        ) : idHelp === HELP_TYPE.INSTRUCTOR.GROUPS_CREATE ? (
                            <HelpInstructorGroupsCreate />
                        ) : idHelp === HELP_TYPE.INSTRUCTOR.GROUP ? (
                            <HelpInstructorGroup />
                        ) : idHelp === HELP_TYPE.INSTRUCTOR.ZTUDENTS ? (
                            <HelpInstructorZtudents />
                        ) : idHelp === HELP_TYPE.INSTRUCTOR.CHANGE_GROUP ? (
                            <HelpInstructorChangeGroup />
                        ) : idHelp === HELP_TYPE.INSTRUCTOR.AGENDA ? (
                            <HelpInstructorAgenda />
                        ) : idHelp === HELP_TYPE.INSTRUCTOR.PROGRESS ? (
                            <HelpInstructorProgress />
                        ) : idHelp === HELP_TYPE.INSTRUCTOR.RESULTS ? (
                            <HelpInstructorResults />
                        ) : idHelp === HELP_TYPE.INSTRUCTOR.ZTUDENTVIEW ? (
                            <HelpInstructorZtudentView />
                        ) : idHelp === HELP_TYPE.INSTRUCTOR.SYLLABUS ? (
                            <HelpInstructorSyllabus />
                        ) : idHelp === HELP_TYPE.INSTRUCTOR.DASHBOARD ? (
                            <HelpInstructorDashboard />
                        ) : idHelp === HELP_TYPE.LEADER.DASHBOARD && (
                            <HelpLeaderDashboard />
                        )}
                    </div>
                </Details>
            )}

            {/* ======================= MODAL MI CUENTA ======================= */}
            {showMyAccountModal && (
                userData ? (
                    <Details
                        showCloseModalButtonInContent={false}
                        extraClassName={'Instructor__Ztudents__Details'}
                        setShowModal={setShowMyAccountModal}
                    >
                        <div className='Instructor__Ztudents__Details__Container'>
                            <p className='Instructor__Ztudents__Details__Title'>Mi cuenta</p>

                            <p>Nombre completo: {userData.name}</p>
                            <p>Correo electrónico: {userData.email}</p>

                            {/* Fila de alias + botón para editar */}
                            <p>
                                Alias: {userData.nickname}
                                <button type='button' className='Btn__Ztudia--PrimaryOutline Instructor__Header__EditButtons' onClick={OpenEditNicknameModal}>
                                    <i className="bi bi-pencil"></i>
                                </button>
                            </p>
                        </div>
                    </Details>
                ) : (
                    <Details
                        showCloseModalButtonInContent={false}
                        extraClassName={'Instructor__Ztudents__Details'}
                        setShowModal={setShowMyAccountModal}
                    >
                        <div className='Instructor__Ztudents__Details__Container'>
                            <p>No ha sido posible obtener la información de tu cuenta.</p>
                            <p>Inténtalo nuevamente o inténtalo más tarde.</p>
                        </div>
                    </Details>
                )
            )}

            {/* ======================= MODAL EDITAR ALIAS ======================= */}
            {showEditNicknameModal && (
                <Details
                    showCloseModalButtonInContent={false}
                    extraClassName={'Instructor__Ztudents__Details'}
                    setShowModal={setShowEditNicknameModal}
                >
                    <div className='Instructor__Ztudents__Details__Container'>
                        <p className='Instructor__Ztudents__Details__Title'>Editar alias</p>

                        <p>Alias actual:</p>
                        <p>{userData?.nickname ?? 'Aún no has establecido un alias'}</p>
                        
                        <label htmlFor='nicknameInput'>Nuevo alias:</label>
                        <input id='nicknameInput' type='text' className='Instructor__Header__Modal--Edit__Input' value={nicknameInput} onChange={(e) => setNicknameInput(e.target.value)} />

                        <div className='Instructor__Groups__Modal--Edit__Buttons'>
                            <button type='button' className='Btn__Ztudia--Primary Instructor__Groups__Modal--Edit__Buttons__Button' onClick={HandleNicknameSubmit}>Guardar cambios</button>
                            <button type='button' className='Btn__Ztudia--DangerOutline Instructor__Groups__Modal--Edit__Buttons__Button' onClick={() => setShowEditNicknameModal(false)}>Cancelar</button>
                        </div>
                    </div>
                </Details>
            )}

            {/* ======================= MODAL CONFIRMACIÓN ALIAS ======================= */}
            {showConfirmNicknameModal && pendingNickname && (
                <Confirm
                    // Mostramos alias actual (A) y alias nuevo (B)
                    message={`¿Estás segur@ de cambiar el alias ${userData?.nickname ? ` '${userData?.nickname}' ` : ''}a '${pendingNickname}'?`}
                    actionToYesButton={UpdateNickname}
                    textYesButton={isSavingNickname ? 'Guardando...' : 'Sí, cambiar alias ahora'}
                    textNoButton={'No'}
                    setShowModal={setShowConfirmNicknameModal}
                    setConfirmData={setPendingNickname}
                />
            )}

            {/* ======================= MODAL DE INTEROPERABILIDAD ======================= */}
            {showInteroperabilityModal && (
                <Details
                    showCloseModalButtonInContent={false}
                    extraClassName={'Instructor__Ztudents__Details'}
                    setShowModal={setShowInteroperabilityModal}
                >
                    <div className='Instructor__Ztudents__Details__Container'>
                        <p className='Instructor__Ztudents__Details__Title'><i className="bi bi-info-circle"></i> Interoperabilidad</p>

                        <p>Ztudia está desarrollado para funcionar junto con las herramientas y sistemas que ya utilizan las instituciones educativas. A continuación, se presenta un resumen de las integraciones disponibles, los datos que se transfieren y las plataformas compatibles.</p>

                        <p className='Help__Title mt-5'>Reportes en MS Excel</p>
                        <p>Exporta reportes directamente desde el perfil del Instructor</p>

                        <p className='Help__Text--Highlight'>¿Cómo se exporta?</p>
                        <p>Desde la opción <span className='Help__Text--Highlight'>Progreso de mis Ztudiantes</span> el Instructor puede consultar el avance del grupo.</p>
                        <img src='/img/support/interoperability/instructor/1.png' className='Help__Image' />
                        <p>Al aplicar los filtros de <span className='Help__Text--Highlight'>Curso</span> y <span className='Help__Text--Highlight'>Grupo</span>, se habilita el botón <span className='Help__Text--Highlight'>Exportar</span> para generar el reporte en formato de MS Excel.</p>
                        <img src='/img/support/interoperability/instructor/2.png' className='Help__Image' />

                        <p className='Help__Text--Highlight'>Datos que se exportan a un archivo de MS Excel</p>
                        <div className='Help__Table'>
                            <div className='Help__Table__Container'>
                                <div className='Help__Table__Row'>
                                    <div className='Help__Table__Row__Column'>
                                        <p className='Help__Table__Row__Column__Highlight'>Nombre del campo</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p className='Help__Table__Row__Column__Highlight'>Tipo de dato</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p className='Help__Table__Row__Column__Highlight'>Descripción</p>
                                    </div>
                                </div>

                                <div className='Help__Table__Row'>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Curso</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Cadena de texto</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Nombre del curso impartido al grupo</p>
                                    </div>
                                </div>

                                <div className='Help__Table__Row'>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Grupo</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Cadena de texto</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Nombre del grupo al que corresponde el reporte</p>
                                    </div>
                                </div>

                                <div className='Help__Table__Row'>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Total</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Numérico</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Cantidad de alumnos registrados en el grupo</p>
                                    </div>
                                </div>

                                <div className='Help__Table__Row'>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Nombre</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Cadena de texto</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Nombre completo de los alumnos inscritos</p>
                                    </div>
                                </div>

                                <div className='Help__Table__Row'>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Usuario</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Cadena de texto</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Nombre único con el que inicia sesión el Ztudiante</p>
                                    </div>
                                </div>

                                <div className='Help__Table__Row'>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Avance general</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Numérico</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Porcentaje de avance del alumno en el temario del curso (0%–100%)</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <img src='/img/support/interoperability/instructor/3.png' className='Help__Image' />

                        <p>Desde la opción <span className='Help__Text--Highlight'>Resultados de mis Ztudiantes</span> el Instructor puede consultar los resultados de las evaluaciones presentadas por el grupo o alumno en específico.</p>
                        <img src='/img/support/interoperability/instructor/4.png' className='Help__Image' />

                        <p>El botón <span className='Help__Text--Highlight'>Exportar reporte completo</span> genera un reporte en MS Excel con los resultados de todas las evaluaciones presentadas por los Ztudiantes. Al aplicar los filtros de <span className='Help__Text--Highlight'>Curso</span>, <span className='Help__Text--Highlight'>Grupo</span>, <span className='Help__Text--Highlight'>Tipo de evaluación</span> se habilita el botón Exportar para generar el reporte en formato MS Excel.</p>
                        <img src='/img/support/interoperability/instructor/5.png' className='Help__Image' />

                        <p className='Help__Text--Highlight'>Datos que se exportan a un archivo de MS Excel</p>
                        <div className='Help__Table'>
                            <div className='Help__Table__Container'>
                                <div className='Help__Table__Row'>
                                    <div className='Help__Table__Row__Column'>
                                        <p className='Help__Table__Row__Column__Highlight'>Nombre del campo</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p className='Help__Table__Row__Column__Highlight'>Tipo de dato</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p className='Help__Table__Row__Column__Highlight'>Descripción</p>
                                    </div>
                                </div>

                                <div className='Help__Table__Row'>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Curso</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Cadena de texto</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Nombre del curso impartido al grupo</p>
                                    </div>
                                </div>

                                <div className='Help__Table__Row'>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Grupo</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Cadena de texto</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Nombre del grupo al que corresponde el reporte</p>
                                    </div>
                                </div>

                                <div className='Help__Table__Row'>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Evaluación</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Cadena de texto</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Tipo de evaluación y nombre del bloque de conocimiento</p>
                                    </div>
                                </div>

                                <div className='Help__Table__Row'>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Página actual</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Numérico</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Número de página del reporte</p>
                                    </div>
                                </div>

                                <div className='Help__Table__Row'>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Tamaño de página</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Numérico</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Cantidad de registros que muestra en el reporte</p>
                                    </div>
                                </div>

                                <div className='Help__Table__Row'>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Total registros (página)</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Numérico</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Cantidad de registros en el reporte</p>
                                    </div>
                                </div>

                                <div className='Help__Table__Row'>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Nombre</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Cadena de texto</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Nombre completo de los alumnos inscritos</p>
                                    </div>
                                </div>

                                <div className='Help__Table__Row'>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Usuario</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Cadena de texto</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Nombre único con el que inicia sesión el Ztudiante</p>
                                    </div>
                                </div>

                                <div className='Help__Table__Row'>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Oportunidad</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Numérico</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Número de intento en que se realizó la evaluación</p>
                                    </div>
                                </div>

                                <div className='Help__Table__Row'>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Tipo de evaluación</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Cadena de texto</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Nombre del bloque de conocimiento</p>
                                    </div>
                                </div>

                                <div className='Help__Table__Row'>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Fecha y hora de finalización</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Fecha y hora</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Fecha y hora en que se completó la evaluación</p>
                                    </div>
                                </div>

                                <div className='Help__Table__Row'>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Calificación</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Numérico</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Puntaje obtenido en la evaluación</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <img src='/img/support/interoperability/instructor/6.png' className='Help__Image' />

                        <p className='Help__Title mt-5'>Comunicación a través de Discord</p>
                        <p>Notificaciones en tiempo real. El equipo de Ztudia configura la integración a petición del instructor.</p>
                        <img src='/img/support/interoperability/instructor/7.jpg' className='Help__Image' />

                        <p className='Help__Text--Highlight'>Eventos que disparan una notificación</p>
                        <ul>
                            <li>Alta de nuevo usuario: se envía cuando se crea una cuenta de alumno en la plataforma</li>
                            <li>Inicio de sesión del alumno: se envía cuando un alumno accede a su cuenta</li>
                            <li>Entrega de evaluación: se envía cuando un alumno completa y envía una evaluación</li>
                        </ul>

                        <div className='Help__Table'>
                            <div className='Help__Table__Container'>
                                <div className='Help__Table__Row'>
                                    <div className='Help__Table__Row__Column'>
                                        <p className='Help__Table__Row__Column__Highlight'>Nombre del campo</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p className='Help__Table__Row__Column__Highlight'>Tipo de dato</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p className='Help__Table__Row__Column__Highlight'>Descripción</p>
                                    </div>
                                </div>

                                <div className='Help__Table__Row'>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Nombre</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Cadena de texto</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Nombre completo del ztudiante registrado</p>
                                    </div>
                                </div>

                                <div className='Help__Table__Row'>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Usuario</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Cadena de texto</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Nombre único con el que inicia sesión el Ztudiante</p>
                                    </div>
                                </div>

                                <div className='Help__Table__Row'>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Fecha y hora</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Fecha y hora</p>
                                    </div>
                                    <div className='Help__Table__Row__Column'>
                                        <p>Fecha y hora en que se registró</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <p className='Help__Title mt-5'>Integración con aplicaciones profesionales</p>
                        <p>Los alumnos aprenden y son evaluados con las aplicaciones reales. Los alumnos no trabajan en entornos simulados: practican y completan sus evaluaciones dentro del mismo software que utilizarán en su vida profesional.</p>
                        <p>Aplicaciones en las que Ztudia coloca los escenarios para que los alumnos respondan.</p>

                        <div className='Help__TableTwoColumn'>
                            <div className='Help__TableTwoColumn__Container'>
                                <div className='Help__TableTwoColumn__Row'>
                                    <div className='Help__TableTwoColumn__Row__Column'>
                                        <p className='Help__TableTwoColumn__Row__Column__Highlight'>Aplicación</p>
                                    </div>
                                    <div className='Help__TableTwoColumn__Row__Column'>
                                        <p className='Help__TableTwoColumn__Row__Column__Highlight'>Área de aprendizaje</p>
                                    </div>
                                </div>

                                <div className='Help__TableTwoColumn__Row'>
                                    <div className='Help__TableTwoColumn__Row__Column'>
                                        <p>Microsoft Word</p>
                                    </div>
                                    <div className='Help__TableTwoColumn__Row__Column'>
                                        <p>Creación y formato de documentos</p>
                                    </div>
                                </div>

                                <div className='Help__TableTwoColumn__Row'>
                                    <div className='Help__TableTwoColumn__Row__Column'>
                                        <p>Microsoft Excel</p>
                                    </div>
                                    <div className='Help__TableTwoColumn__Row__Column'>
                                        <p>Hojas de cálculo y análisis de datos</p>
                                    </div>
                                </div>

                                <div className='Help__TableTwoColumn__Row'>
                                    <div className='Help__TableTwoColumn__Row__Column'>
                                        <p>Microsoft PowerPoint</p>
                                    </div>
                                    <div className='Help__TableTwoColumn__Row__Column'>
                                        <p>Diseño de presentaciones</p>
                                    </div>
                                </div>

                                <div className='Help__TableTwoColumn__Row'>
                                    <div className='Help__TableTwoColumn__Row__Column'>
                                        <p>Adobe Photoshop CC</p>
                                    </div>
                                    <div className='Help__TableTwoColumn__Row__Column'>
                                        <p>Edición de imagen digital</p>
                                    </div>
                                </div>

                                <div className='Help__TableTwoColumn__Row'>
                                    <div className='Help__TableTwoColumn__Row__Column'>
                                        <p>Editores HTML</p>
                                    </div>
                                    <div className='Help__TableTwoColumn__Row__Column'>
                                        <p>Desarrollo web (cualquier editor, incluyendo Bloc de notas)</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <p className='Help__Title mt-5'>Acceso desde navegador web</p>
                        <p>Instructores y Ztudiantes acceden a Ztudia desde cualquier navegador web moderno. No se requieren complementos ni extensiones.</p>

                        <ul>
                            <li>Navegadores compatibles:</li>
                            <li>Google Chrome</li>
                            <li>Mozilla Firefox</li>
                            <li>Microsoft Edge</li>
                            <li>Safari</li>
                            <li>Opera</li>
                        </ul>

                        {/* <span className='Help__Text--Highlight'>Mis resultados</span> */}
                        {/* <p className='Help__Text--Italic'></p> */}
                        {/* <p className='Help__Title'>Mis resultados</p> */}
                    </div>
                </Details>
            )}
        </>
    )
}

export { SideMenu };